import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 bg-[#0A0A0A] relative overflow-hidden" data-id="element-124">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#C5A55A]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-125"></div>

      <div className="max-w-3xl mx-auto px-4 relative z-10 text-center" data-id="element-126">
        <motion.div className="bg-gradient-to-b from-[#1a1a1a] to-[#0A0A0A] border border-[#C5A55A] p-8 md:p-16 rounded-lg shadow-[0_0_50px_rgba(197,165,90,0.15)]" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-127">
          <h2 className="text-2xl md:text-3xl font-serif text-[#FAF7F2] mb-2" data-id="element-128">
            Inmersión Pareja: 18 Métodos
          </h2>
          <p className="text-[#C5A55A] uppercase tracking-widest text-sm mb-8" data-id="element-129">
            En vivo · Jueves 12 de febrero
          </p>

          <div className="flex items-baseline justify-center gap-2 mb-10" data-id="element-130">
            <span className="text-[#FAF7F2]/60 text-lg" data-id="element-131">Acceso completo:</span>
            <span className="text-5xl md:text-6xl font-bold text-[#FAF7F2] font-serif" data-id="element-132">
              $27 USD
            </span>
          </div>

          <motion.a href="https://pay.hotmart.com/O104329024S?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-[#B91C1C] hover:bg-[#991b1b] text-white text-lg md:text-xl font-medium py-4 px-8 rounded-sm shadow-[0_0_20px_rgba(185,28,28,0.4)] hover:shadow-[0_0_40px_rgba(185,28,28,0.6)] transition-all duration-300 flex items-center justify-center gap-3 group mb-6" data-id="element-133">
            Elegirnos también se entrena — Reservar mi cupo
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-134" />
          </motion.a>

          <p className="text-[#FAF7F2]/40 text-sm" data-id="element-135">
            Pago seguro · Acceso inmediato al email
          </p>
        </motion.div>
      </div>
    </section>;
}